// @ts-check
import {ComboSegmentSection} from './ComboSegmentSection'
import {ComboSetupSection} from './ComboSetupSection'
import {SnacksAndBevarages} from './SnacksAndBevarages'

export const ProductComboSetup = () => {
  return (
    <div className="flex flex-col gap-6">
      <ComboSetupSection />

      <div className="flex flex-col gap-6 rounded-lg bg-[var(--color-background-layer-01)] p-4">
        <ComboSegmentSection />
        <div className="h-px bg-[var(--secondary-800)]" />
        <SnacksAndBevarages />
      </div>
    </div>
  )
}
